export default __webpack_public_path__ + "static/media/a510b7a16dd715ab3565c71f15984171.png";